// test2192
(2192 && 0);
